import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Building2, Home, TrendingUp, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Services = () => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const services = [
    {
      icon: <Building2 size={32} />,
      title: t('services.corporate'),
      description: t('services.corporateDesc'),
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1000'
    },
    {
      icon: <Home size={32} />,
      title: t('services.residential'),
      description: t('services.residentialDesc'),
      image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1000'
    },
    {
      icon: <TrendingUp size={32} />,
      title: t('services.infrastructure'),
      description: t('services.infrastructureDesc'),
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=1000'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="services-title">{t('services.title')}</h2>
          <p className="services-subtitle">{t('services.subtitle')}</p>
        </motion.div>

        <motion.div 
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={itemVariants}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              whileHover={{ 
                y: -12, 
                scale: 1.02,
                transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }
              }}
            >
              <div className="service-image-wrapper">
                <motion.img 
                  src={service.image} 
                  alt={service.title} 
                  className="service-image"
                  animate={{
                    scale: hoveredIndex === index ? 1.1 : 1
                  }}
                  transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                />
                <div className="service-image-overlay"></div>
              </div>
              <div className="service-content">
                <div className="service-icon-wrapper">
                  <motion.div 
                    className="service-icon"
                    animate={{
                      rotate: hoveredIndex === index ? 360 : 0,
                      scale: hoveredIndex === index ? 1.1 : 1,
                      backgroundColor: hoveredIndex === index ? '#D4AF37' : 'rgba(212, 175, 55, 0.15)'
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    {service.icon}
                  </motion.div>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <motion.button 
                  className="service-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span>{t('services.learnMore') || 'Detaylı Bilgi'}</span>
                  <motion.div
                    animate={{
                      x: hoveredIndex === index ? 5 : 0
                    }}
                    transition={{ duration: 0.3 }}
                  >
                    <ArrowRight size={18} />
                  </motion.div>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
